module.exports = __webpack_public_path__ + "static/img/Bachelor_010658.3792581.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010658.jpg
// module id = 202
// module chunks = 0